module.exports = __webpack_public_path__ + "img/card_impactos.84811f87.jpg";